window._ = require("lodash");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");

    require("bootstrap");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import "slick-carousel";

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
//
//
//
$(window).on("load resize", function() {
    $(".nav-mega-menu").each(function() {
        const $this = $(this);
        const $parent = $(this).closest(".has-children");
        $this.css("padding-left", $parent.offset().left + 20);
    });
});

const imagesToBeHiddenFromReaders = ["Icon", "image", "Image"];

$("img").each(function() {
    const $this = $(this);
    const altAttr = $this.attr("alt");

    if (
        imagesToBeHiddenFromReaders.includes(altAttr) ||
        altAttr === undefined
    ) {
        console.log($this);
        $this
            .attr("role", "presentation")
            .attr("aria-hidden", "true")
            .attr("alt", "");
    }
});

$("a[href='#learn-more']").each(function() {
    const $this = $(this);

    $this.attr(
        "title",
        "Button which scrolls the page to the section with more information regarding the service"
    );
});

$(".check-icon").each(function() {
    const $this = $(this);
    const element = `<span class="sr-only">Checkmark</span>`;

    $this
        .removeAttr("aria-label")
        .attr("aria-hidden", "true")
        .attr("role", "presentation");
    $this.after(element);
});

$(".header .nav .has-children > a").on("click", function(e) {
    e.preventDefault();

    $(this)
        .parent()
        .toggleClass("active")
        .siblings()
        .removeClass("active");
});
$(".custom-text .collapse").on("show.bs.collapse", function() {
    const $content = $('a[data-bs-target="#' + $(this).attr("id") + '"]');

    $content.text("Read less");
});

$(".custom-text .collapse").on("hidden.bs.collapse", function() {
    const $content = $('a[data-bs-target="#' + $(this).attr("id") + '"]');

    $content.text("Read more");
});

$(window).on("load", function() {
    if ($(".slick-slider")) {
        $(".slick-slider").slick({
            nextArrow: '<i class="fas fa-chevron-right" to="next"></i>',
            prevArrow: '<i class="fas fa-chevron-left" to="prev"></i>',
            dots: true,
            adaptiveHeight: true
        });
    }

    if ($(".slick-infinite")) {
        $(".slick-infinite").slick({
            speed: 8000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: false,
            infinite: true,
            swipeToSlide: true,
            centerMode: true
        });
    }
});
